import { DENTIST_STATUS_ORDER, dentistStatusBucket, type DentistStatusBucket } from "./dentist-status";
import type { ProsthesisOrderRow } from "./types";

export type OrderSortField = "none" | "createdAt" | "deadline" | "status" | "lab" | "patient";
export type SortDirection = "asc" | "desc";

/** Ordem de status pra sort — inclui Recusado/Cancelado no fim, que não aparecem
 *  nos botões de filtro (ver DENTIST_STATUS_ORDER) mas podem existir na lista sem filtro. */
const STATUS_SORT_ORDER: DentistStatusBucket[] = [...DENTIST_STATUS_ORDER, "RECUSADO", "CANCELADO"];

function compareDates(a: Date | string | null, b: Date | string | null): number {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return new Date(a).getTime() - new Date(b).getTime();
}

function compareByField(field: OrderSortField, a: ProsthesisOrderRow, b: ProsthesisOrderRow): number {
  switch (field) {
    case "createdAt":
      return compareDates(a.createdAt, b.createdAt);
    case "deadline":
      return compareDates(a.deadline, b.deadline);
    case "status":
      return (
        STATUS_SORT_ORDER.indexOf(dentistStatusBucket(a.status)) -
        STATUS_SORT_ORDER.indexOf(dentistStatusBucket(b.status))
      );
    case "lab":
      return (a.labName ?? "").localeCompare(b.labName ?? "", "pt-BR");
    case "patient":
      return a.patientName.localeCompare(b.patientName, "pt-BR");
    default:
      return 0;
  }
}

/** Clique no título da coluna ordena por ela — um campo só, sem menu (mais simples pra
 *  quem não tem intimidade com software). Clicar de novo no mesmo campo inverte a direção. */
export function makeOrderComparator(field: OrderSortField, direction: SortDirection) {
  return (a: ProsthesisOrderRow, b: ProsthesisOrderRow) => {
    if (field === "none") return 0;
    const result = compareByField(field, a, b);
    return direction === "desc" ? -result : result;
  };
}
